import React from 'react';
import { Col, DatePicker, Form, Input, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import Helpers from 'helpers';
import { renderGroupedShopOptions } from 'components/shopOptions';

const InfoSection = ({ shops, inactiveShops, extrastockTypes }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Informazioni Generali')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Insegna')} name='company_id'>
          <Select
            {...Helpers.addSearchProps()}
            placeholder={t('Selezioni opzione')}
          >
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {renderGroupedShopOptions({
              shops,
              inactiveShops,
              t,
            })}
          </Select>
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Tipologia Stock')} name='extrastock_type'>
          <Select placeholder={t('Selezioni opzione')}>
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {Object.entries(extrastockTypes).map((i) => (
              <Select.Option key={i[0]} value={i[0]}>
                {i[1]}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col offset={6} span={4}>
        <Form.Item label={t('Data dal')} name='date_from'>
          <DatePicker format={'DD MMMM YYYY'} />
        </Form.Item>
      </Col>
      <Col offset={1} span={4}>
        <Form.Item label={t('Data al')} name='date_to'>
          <DatePicker format={'DD MMMM YYYY'} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Nome richiedente')} name='manager_name'>
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
